import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { MotionConfig } from "framer-motion";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { readCachedSettings } from "./hooks/useSettings";
import { applyTheme } from "./theme";
import "./styles/theme.css";
import "./styles/app.css";

// Apply the last-known theme/accent before first paint so a reload doesn't
// flash the wrong palette (fallback = default dark/teal).
const cached = readCachedSettings();
applyTheme(cached?.theme ?? "dark", cached?.accent ?? "teal");

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

if ("serviceWorker" in navigator) {
  void navigator.serviceWorker.register("/sw.js").catch(() => {
    /* push is optional; ignore registration failures */
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <MotionConfig transition={{ ease: [0.22, 1, 0.36, 1] }}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </MotionConfig>
  </React.StrictMode>,
);